import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Button, Input, Modal } from '@enterprise-ui/canvas-ui-react'

export const ViewByModal = (props) => {
  const { showModal, onClose, onSelect } = props
  const navigate = useNavigate()

  const [questionIndex, setQuestionIndex] = useState(0)
  const [answerState, setAnswerState] = useState(false)
  const [count, setCount] = useState(0)
  const questionArray = [
    {
      question:
        "Is your item's cost to Target the same regardless of which location it is shipped to?",
      yesAnswer: 'Select "Chain"',
      field: 'CHAIN',
    },
    {
      question:
        'Do your costs vary based on which Target Distrubution Center you ship to?',
      yesAnswer: 'Select "DC" and select which DC\'s you ship to.',
      field: 'DC',
    },
    {
      question:
        'Do your costs vary based on the state the Target store is located?',
      yesAnswer:
        'Select "State" and select which States you manage the cost for.',
      field: 'STATE',
    },
    {
      question:
        'Do you have groups of Target Stores which will always have the same cost?',
      yesAnswer:
        'Select "Location" and select which locations you manage the cost for.',
      field: 'LOCATION',
    },
  ]

  useEffect(() => {
    setQuestionIndex(0)
    setAnswerState(false)
  }, [showModal])

  return (
    <>
      <Modal
        data-testid="view-by-modal"
        headingText="View By Suggestion"
        isVisible={showModal}
        onRefuse={() => {
          onClose()
        }}
      >
        {!answerState && questionIndex < 4 ? (
          <>
            <div className="hc-pa-normal hc-ma-normal">
              <p>{questionArray[questionIndex].question}</p>
              <Input.Radio
                data-testid={'question-' + questionIndex}
                id={'question-' + count}
                options={[
                  {
                    value: 'yes-' + count,
                    label: 'Yes',
                  },
                  {
                    value: 'no-' + count,
                    label: 'No',
                  },
                ]}
                onUpdate={(id, value) => {
                  setCount(count + 1)
                  if (value === 'yes-' + count) {
                    setAnswerState(true)
                  } else {
                    setQuestionIndex(questionIndex + 1)
                  }
                }}
              />
            </div>
            {questionIndex > 0 ? (
              <Button
                className="hc-ma-normal"
                onClick={() => {
                  setQuestionIndex(questionIndex - 1)
                }}
              >
                Back
              </Button>
            ) : null}
          </>
        ) : null}
        {answerState ? (
          <>
            <div className="hc-pa-normal hc-ma-normal">
              <p>{questionArray[questionIndex].yesAnswer}</p>
            </div>
            <div
              className="hesp-general-flex"
              style={{ justifyContent: 'space-between' }}
            >
              <Button
                className="hc-ma-normal"
                onClick={() => {
                  setAnswerState(false)
                  setQuestionIndex(questionIndex)
                }}
              >
                Back
              </Button>
              <Button
                data-testid="select-button"
                className="hc-ma-normal hesp-general-marginLeft"
                type="primary"
                onClick={() => {
                  onSelect(questionArray[questionIndex].field)
                  onClose()
                }}
              >
                Select
              </Button>
            </div>
          </>
        ) : null}
        {questionIndex === 4 ? (
          <>
            <div className="hc-pa-normal hc-ma-normal">
              <p>Create or select an existing Custom Location Group.</p>
            </div>
            <div
              className="hesp-general-flex"
              style={{ justifyContent: 'space-between' }}
            >
              <Button
                className="hc-ma-normal"
                onClick={() => setQuestionIndex(questionIndex - 1)}
              >
                Back
              </Button>
              <div className="hesp-general-flex">
                <Button
                  data-testid="existing-button"
                  className="hc-ma-normal hesp-general-marginLeft"
                  type="secondary"
                  onClick={() => {
                    onSelect('CUSTOM')
                    onClose()
                  }}
                >
                  Existing
                </Button>
                <Button
                  data-testid="create-button"
                  className="hc-ma-normal hesp-general-marginLeft hesp-general-flex"
                  type="primary"
                  onClick={() => {
                    navigate('/manage-custom-location-groups')
                    onClose()
                  }}
                >
                  Create
                </Button>
              </div>
            </div>
          </>
        ) : null}
      </Modal>
    </>
  )
}
